import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { Link } from "react-router-dom";
import { db } from "../firebase";

export default function PiecesHighlightSection() {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    const fetchPieces = async () => {
      try {
        const q = query(
          collection(db, "pieces_detachees"),
          where("enLigne", "==", true),
          where("isFeatured", "==", true)
        );
        const snap = await getDocs(q);
        const data = snap.docs.map((d) => ({ id: d.id, ...d.data() })).slice(0, 6);
        setPieces(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchPieces();
  }, []);

  if (pieces.length === 0) return null;

  return (
    <section className="py-5 bg-white border-top border-bottom">
      <div className="container">
        <div className="text-center mb-5">
          <span className="badge bg-danger px-3 py-2 mb-3">
            Pièces détachées
          </span>
          <h2 className="fw-bold">Besoin d’une pièce détachée ?</h2>
          <p className="text-muted">
            Trouvez rapidement vos pièces auto et contactez THE BRIDGE pour commander.
          </p>
        </div>

        <div className="row g-4">
          {pieces.map((piece) => (
            <div key={piece.id} className="col-6 col-md-4 col-xl-2">
              <Link
                to={`/piece/${piece.slug}`}
                className="text-decoration-none text-dark"
              >
                <div className="card h-100 shadow-sm border-0 piece-highlight-card">
                  <img
                    src={piece.imageUrls?.[0] || "/assets/default.jpg"}
                    alt={piece.nom}
                    className="card-img-top"
                    style={{ height: "160px", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <h6 className="fw-bold small">{piece.nom}</h6>
                    <p className="text-muted small mb-1">{piece.marque}</p>
                    <p className="fw-bold text-primary small mb-0">
                      {piece.prix > 0
                        ? `${Number(piece.prix).toLocaleString("fr-FR")} FCFA`
                        : "Prix sur demande"}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-4">
          <Link to="/pieces-detachees" className="btn btn-bridge">
            Voir toutes les pièces
          </Link>
        </div>

        <style>{`
          .piece-highlight-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .piece-highlight-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 1rem 2rem rgba(0,0,0,.12) !important;
          }
        `}</style>
      </div>
    </section>
  );
}
